import { render, staticRenderFns } from "./SupportingSeries.vue?vue&type=template&id=5340665c&"
import script from "./SupportingSeries.vue?vue&type=script&lang=js&"
export * from "./SupportingSeries.vue?vue&type=script&lang=js&"
import style0 from "./SupportingSeries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports